var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { default as CategoryFilterView } from './CategoryFilter';
import { default as SongFilter } from './SongFilter';
import Box from '../Box';
var SearchBox = /** @class */ (function (_super) {
    __extends(SearchBox, _super);
    function SearchBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchBox.prototype.render = function () {
        var _this = this;
        var _a = this.props, style = _a.style, rest = __rest(_a, ["style"]);
        return React.createElement(Box, { style: style },
            React.createElement(CategoryFilterView, __assign({ ref: function (ref) { return _this.categoryFilter = ref; } }, rest, { noBox: true })),
            React.createElement(SongFilter, __assign({}, rest, { noBox: true, style: { marginTop: '20px' }, onReset: function () {
                    _this.categoryFilter && _this.categoryFilter.reset();
                } })));
    };
    return SearchBox;
}(React.Component));
export default SearchBox;
//# sourceMappingURL=SearchBox.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/filter/SearchBox.js
// module id = 1316
// module chunks = 0